<script>
import { mdbBtn, mdbBtnGroup, mdbIcon } from 'mdbvue'
const SORT_DIRECTION_ASC = 'asc'
const SORT_DIRECTION_DESC = 'desc'
export default {
  created () {
    this.$store.dispatch('reports/RETRIEVE_LIST')
    this.$root.$on('ReportsSearchPhrase', this.onSearchPhraseChange)
  },
  data: () => ({
    fields: [
      {
        label: 'Rok',
        key: 'date',
        formatter: 'formatterGetYear'
      },
      {
        label: 'Miesiąc',
        key: 'date',
        formatter: 'formatterGetMonth'
      },
      {
        label: 'Data',
        key: 'date',
        formatter: 'formatterGetDate'
      },
      {
        label: 'Dost',
        key: 'supplier'
      },
      {
        label: 'Serwis',
        key: 'portal'
      },
      {
        label: 'TG',
        key: 'target'
      },
      {
        label: 'Usługa',
        key: 'service'
      },
      {
        label: 'NR CL',
        key: 'materials'
      },
      // {
      //   label: 'Kreacja',
      //   key: 'creation'
      // },
      {
        label: 'Tytuł',
        key: 'title'
      },
      {
        label: 'Produkt',
        key: 'product'
      },
      {
        label: 'PV',
        key: 'display'
      },
      {
        label: 'OR un',
        key: 'open'
      },
      {
        label: 'Kliki',
        key: 'click'
      },
      {
        label: 'OR',
        key: 'openRate',
        formatter: 'formatterPercent',
        cellClasses: ['cell-percent']
      },
      {
        label: 'CTR',
        key: 'ctr',
        formatter: 'formatterPercent',
        cellClasses: ['cell-percent']
      },
      {
        label: 'Koszt',
        key: 'cost',
        formatter: 'formatterCurrency',
        cellClasses: ['cell-currency']
      },
      {
        label: 'zł/1kPV',
        key: 'cost1K',
        formatter: 'formatterCurrency',
        cellClasses: ['cell-currency']
      },
      {
        label: 'zł/OR',
        key: 'openRateCost',
        formatter: 'formatterCurrency',
        cellClasses: ['cell-currency']
      },
      {
        label: 'zł/CTR',
        key: 'ctrCost',
        formatter: 'formatterCurrency',
        cellClasses: ['cell-currency']
      }
    ],
    sortBy: null,
    sortDirection: null,
    searchPhrase: ''
  }),
  computed: {
    reports () {
      let reports = this.$store.getters['reports/REPORTS']({
        sortBy: this.sortBy,
        sortDirection: this.sortDirection
      })
      if (this.searchPhrase) {
        reports = reports.filter(report => {
          let isAnyFieldMatched = false
          this.fields.forEach(field => {
            let value = this.getCellContent(report, field)
            if (value.toString().toLowerCase().indexOf(this.searchPhrase.toLowerCase()) !== -1) {
              isAnyFieldMatched = true
            }
          })
          return isAnyFieldMatched
        })
      }
      return reports
    },
  },
  methods: {
    getCellContent (report, field) {
      if (typeof report[field.key] === 'undefined') {
        return field.key
      }
      let content = report[field.key]
      if (typeof field.formatter !== 'undefined') {
        content = this[field.formatter](report, field.key)
      }
      return content
    },
    formatterGetYear (report, key) {
      return report[key].year()
    },
    formatterGetMonth (report, key) {
      return this.$t('months.' + (report[key].month() + 1))
    },
    formatterGetDate (report, key) {
      return report[key].format("DD.MM.YYYY")
    },
    formatterPercent (report, key) {
      return report[key] + ' %'
    },
    formatterCurrency (report, key) {
      return report[key] + ' PLN'
    },
    getCellClasses (report, field) {
      if (typeof field.cellClasses !== 'undefined') {
        return field.cellClasses
      } else {
        return []
      }
    },
    onThClick (field) {
      if (this.sortBy === field) {
        this.sortDirection = this.sortDirection === SORT_DIRECTION_ASC
          ? SORT_DIRECTION_DESC
          : SORT_DIRECTION_ASC
      } else {
        this.sortBy = field
        this.sortDirection = SORT_DIRECTION_ASC
      }
    },
    onSearchPhraseChange (phrase) {
      this.searchPhrase = phrase
    },
    addReportClick () {
      this.$emit('showAddReportModal')
    },
    previewClick (reportId) {
      this.$emit('showVisualPrevieModal', { reportId })
    },
    editReportClick (reportId) {
      this.$emit('showEditReportModal', { reportId })
    },
    deleteReportClick (reportId) {
      this.$emit('showRemoveReportModalConfirm', { reportId })
    },
  },
  components: {
    mdbBtn,
    mdbBtnGroup,
    mdbIcon,
    VisualPrevieModal: () => import('@/components/reports/VisualPrevieModal'),
    AddReportModal: () => import('@/components/reports/add/AddReportModal'),
    RemoveReportConfirmModal: () => import('@/components/reports/remove/RemoveReportConfirmModal')
  }
}
</script>

<template>
  <div>
    <div class="rwd-table-wrapper" v-if="reports.length">
      <table class="rwd-table">
        <thead>
          <tr>
            <th
              v-for="(field, index) in fields"
              :key="index"
              @click.prevent="onThClick(field.key)"
            >
              {{ field.label }}
              <span v-show="field.key != sortBy">
                <mdb-icon icon="sort" />
              </span>
              <span v-show="field.key == sortBy && sortDirection == 'asc'">
                <mdb-icon icon="sort-up" />
              </span>
              <span v-show="field.key == sortBy && sortDirection == 'desc'">
                <mdb-icon icon="sort-down" />
              </span>
            </th>
            <th>AKCJE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in reports" :key="report.id">
            <td
              v-for="(field, index) in fields"
              :key="index"
              :data-label="field.label"
              :class="getCellClasses(report, field)"
              :data-key="field.key"
            >
              <component
                :is="theComponent"
                v-if="field.component"
                :text="getCellContent(report, field)"
              ></component>
              <div v-html="getCellContent(report, field)" v-else></div>
            </td>
            <td :data-label="'AKCJE:'" class="text-right">
              <mdb-btn-group>
                <mdb-btn
                  v-if="report.visual"
                  color="primary"
                  size="sm"
                  @click="previewClick(report.id)"
                >
                  <mdb-icon icon="eye" />
                </mdb-btn>
                <mdb-btn
                  color="warning"
                  size="sm"
                  @click="editReportClick(report.id)"
                >
                  <mdb-icon icon="edit" />
                </mdb-btn>
                <mdb-btn
                  color="danger"
                  size="sm"
                  @click="deleteReportClick(report.id)"
                >
                  <mdb-icon icon="trash" />
                </mdb-btn>
              </mdb-btn-group>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="text-center">brak wyników</p>
    </div>
    <mdb-btn
      tag="a"
      rounded
      color="primary"
      @click="addReportClick"
      class="add-report-button"
    >
      <mdb-icon icon="plus" />
    </mdb-btn>
    <VisualPrevieModal />
    <AddReportModal />
    <RemoveReportConfirmModal />
  </div>
</template>

<style lang="scss">
  @import 'sass/shared.scss';
  $bp-cards: 1000px;
  .rwd-table-wrapper {
    width: 100%;
    overflow-x: auto;
    @include mediaMax($bp-cards) {
      overflow-x: initial;
    }
  }
  .rwd-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    max-width: 100%;
    margin: 10px 0 20px;
    thead {
      tr {
        border-bottom: 3px solid #0085a6;
        color: #000;
        @include mediaMax($bp-cards) {
          display: none;
        }
      }
      th {
        background-color: #fff;
        color: #000;
        font-size: 0.83333em;
        line-height: 1.8;
        padding: 15px 14px 13px 14px;
        position: relative;
        text-align: center;
        text-transform: uppercase;
        font-size: 15px;
        font-weight: 500;
        white-space: nowrap;
        cursor: pointer;
        .svg-inline--fa {
          margin-left: 5px;
        }
        .fa-sort {
          opacity: 0.2;
        }
      }
    }
    tbody {
      tr {
        background-color: #fff;
        @include mediaMax($bp-cards) {
          display: block;
          margin-bottom: 50px;
          box-shadow: 0 0 5px 0 rgba(#000, 0.4);
          &:last-child {
            margin-bottom: 0;
          }
        }
        @include mediaMin($bp-cards) {
          &:hover {
            background-color: #eee;
            color: #000;
          }
        }
      }
      td {
        font-weight: 400;
        @include mediaMax($bp-cards) {
          display: block;
          background-color: #fff;
          border-top: none;
          position: relative;
          padding-left: 50%;
        }
        &:first-child {
          @include mediaMax($bp-cards) {
            border-top: 1px solid #bfbfbf;
          }
        }
        &:hover {
          @include mediaMax($bp-cards) {
            background-color: #eee;
            color: #000;
          }
          &:before {
            @include mediaMax($bp-cards) {
              color: hsl(0, 0%, 40%);
            }
          }
        }
        &:before {
          @include mediaMax($bp-cards) {
            content: attr(data-label);
            display: inline-block;
            color: hsl(0, 0%, 60%);
            font-size: 14px;
            font-weight: normal;
            margin-left: -100%;
            width: 100%;
            white-space: nowrap;
          }
        }
      }
    }
    th,
    td {
      border: 1px solid #bfbfbf;
      padding: 5px 14px;
      position: relative;
      vertical-align: middle;
      white-space: nowrap;
      @include mediaMax($bp-cards) {
        white-space: initial;
      }
    }
    @include mediaMin($bp-cards + 1) {
      td[data-key='title'],
      td[data-key='target'] {
        &:hover {
          & > div {
            white-space: initial;
            overflow: initial;
            text-overflow: initial;
          }
        }
        & > div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: all 0.2s;
        }
      }
      td[data-key='title'] {
        & > div {
          width: 150px;
        }
      }
      td[data-key='target'] {
        & > div {
          width: 75px;
        }
      }
    }
  }
  .cell-percent {
    background: rgba(#ff0, 0.15);
  }
  .cell-currency {
    background: rgba(#0f0, 0.15);
  }
  .add-report-button {
    position: fixed;
    bottom: 10px;
    right: 10px;
    svg {
      path {
        fill: #fff;
      }
    }
  }
</style>

